import { usePersonalizedTitle } from '../hooks/usePersonalizedTitle';

/** Mounted once so the title query is in flight before the header renders. */
export const PersonalizedTitlePrefetch = () => {
  usePersonalizedTitle();
  return null;
};
//# sourceMappingURL=PersonalizedTitlePrefetch.js.map